import { render, staticRenderFns } from "./V1Client.vue?vue&type=template&id=4a5a3bae&scoped=true&"
import script from "./V1Client.vue?vue&type=script&lang=js&"
export * from "./V1Client.vue?vue&type=script&lang=js&"
import style0 from "./V1Client.vue?vue&type=style&index=0&id=4a5a3bae&scoped=true&lang=css&"
import style1 from "./V1Client.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5a3bae",
  null
  
)

export default component.exports